import { FileText, PenLine } from "lucide-react";
import { Reveal } from "./Motion";
import { SAMPLE_ENTRY as E } from "../data/sample";

const FIELDS = [["Notice", E.notice], ["Explore", E.explore], ["Connect", E.connect]];

export const AfterState = () => (
  <div className="mt-6 grid md:grid-cols-12 gap-4" data-testid="sample-after-state">
    <Reveal className="md:col-span-7">
      <div className="h-full rounded-2xl bg-white border border-navy/10 p-6" data-testid="sample-journal">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="label text-navy/50 inline-flex items-center gap-2"><PenLine size={14} /> A finished reflection</p>
          <span className="text-[11px] text-navy-deep/50 italic">{E.label}</span>
        </div>
        <dl className="mt-4 space-y-3">
          {FIELDS.map(([k, v]) => (
            <div key={k} className="rounded-xl bg-cream/70 border border-navy/10 p-4">
              <dt className="label text-sage">{k}</dt>
              <dd className="mt-1.5 text-navy-deep/85 leading-relaxed font-serif text-lg">{v}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-3 text-xs text-navy-deep/55 flex items-center gap-1.5">Saved to your account · autosaves as you type</p>
      </div>
    </Reveal>
    <Reveal delay={0.1} className="md:col-span-5">
      <div className="h-full rounded-2xl bg-cream border border-navy/15 p-6 shadow-[0_20px_50px_rgba(13,27,42,0.12)] rotate-[0.5deg]" data-testid="sample-provider-sheet">
        <p className="label text-navy/50 inline-flex items-center gap-2"><FileText size={14} /> Provider Conversation Sheet · PDF</p>
        <p className="font-serif text-xl text-navy-deep mt-3 leading-snug">{E.sheetTitle}</p>
        <ol className="mt-4 space-y-3">
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-navy text-cream text-xs flex items-center justify-center shrink-0">1</span>
            <div>
              <p className="text-navy-deep/85 leading-relaxed">{E.connect}</p>
              <p className="mt-1 text-[11px] text-navy-deep/50">{E.sheetSource}</p>
            </div>
          </li>
        </ol>
        <div className="mt-5 space-y-2">
          {[0, 1, 2].map((i) => <div key={i} className="h-px bg-navy/15" />)}
          <p className="text-[10px] text-navy-deep/45 pt-1">Notes</p>
        </div>
        <p className="mt-4 text-xs text-navy-deep/55">One page. Your Connect questions, numbered, ready for the appointment.</p>
      </div>
    </Reveal>
  </div>
);
